module.exports = __webpack_public_path__ + "images/kihnu/android-icon-144x144.png";